import Emitter from '../utils/emitter'
import extractRawElm from '../utils/extract-raw-elm'

import { isElement } from 'lodash-es'
import { before, after } from '../utils/bits'
import { getElmStrShort } from '../utils/get-elm-str'
import { onTransitionEnd, offTransitionEnd } from '../utils/on-transition-end'

export default function TransformDetector($elm) {
  const detector = Emitter(`transformDetector[elm=${getElmStrShort($elm)}]`)

  const observed = []
  const propertyName = 'transform'

  detector.on = before(beforeOn, detector.on)
  detector.pre = before(beforeOn, detector.pre)
  detector.after = before(beforeOn, detector.after)
  detector.off = after(detector.off, afterOff)
  detector.clear = after(detector.clear, afterOff)

  return detector

  function beforeOn() {
    if (detector.size() === 0) {
      const elm = extractRawElm($elm)
      let currElm = elm
      while (isElement(currElm)) {
        observed.push(currElm)
        onTransitionEnd(currElm, propertyName, detector.emit)
        currElm = currElm.parentNode
      }
    }
  }

  function afterOff() {
    if (detector.size() === 0) {
      for (const currElm of observed) {
        offTransitionEnd(currElm, propertyName, detector.emit)
      }
      observed.length = 0
    }
  }
}
